import React, { useState, useEffect } from 'react';
import './App.css';
import Board from './components/Board.jsx';
import Logo from './Logo.png';

function App() {
    const fixedText = "Resisted Sled Training";
    const [headerText, setHeaderText] = useState(fixedText);
    useEffect(() => {
        const header = document.getElementById("myHeader");
        const sticky = header.offsetTop;
        const scrollCallBack = window.addEventListener("scroll", () => {
            if (window.pageYOffset > sticky) {
                header.classList.add("sticky");
                if (headerText !== fixedText) {
                    setHeaderText(fixedText);
                }
            }
            else {
                header.classList.remove("sticky");
                if (headerText !== fixedText) {
                    setHeaderText(fixedText);
                }
            }
        });
        return () => {
            window.removeEventListener("scroll", scrollCallBack);
        };
    }, [headerText]);


    return (
        <div>
            <div className="headerContainer">
                <header id="myHeader" className="header">
                        <img className="imgLogo" src={Logo} alt="Logo" />
              </header>
            </div>
            <div>
              < Board ></Board>
             </div>
        </div>
  );
}

export default App;

//<div>
//    <h1 className="heading1"> {headerText}</h1>
//    <br />
//    <h2 className="heading2">Miche{'\u00E1'}l Cahill PhD</h2>
//</div>